import { render, staticRenderFns } from "./VsCheckBox.vue?vue&type=template&id=7fcc316c&lang=html&"
import script from "./VsCheckBox.vue?vue&type=script&lang=js&"
export * from "./VsCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports